import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchData, postData } from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import { ReasonCaptureModal } from '../Common/ReasonCaptureModal';
import PageLayout from '../Layout/PageLayout';
import { Card, FormField, Select, Button, StatusBadge, Spinner, tokens } from '../UI';

export default function AdminDetails() {
  const { id } = useParams();
  const [admin, setAdmin] = useState(null);
  const [roles, setRoles] = useState([]);
  const [pendingRole, setPendingRole] = useState('');
  const [showReason, setShowReason] = useState(false);

  useEffect(() => {
    fetchData(Endpoints.LIST_ADMINS)
      .then((res) => res.json())
      .then((res) => {
        setAdmin((res.admins || []).find((a) => a.id === id));
      });
    fetchData(Endpoints.LIST_ROLES)
      .then((res) => res.json())
      .then((res) => setRoles(res.roles || []));
  }, [id]);

  if (!admin) return <Spinner center label="Loading…" />;

  const submit = (reason) => {
    const fd = new FormData();
    fd.append('role', pendingRole);
    fd.append('reason', reason);
    postData(Endpoints.ASSIGN_ROLE(id), fd)
      .then((res) => res.json())
      .then((updated) => {
        setAdmin(updated);
        setShowReason(false);
        setPendingRole('');
      });
  };

  return (
    <PageLayout title={admin.name}>
      <Card style={{ maxWidth: 560 }}>
        <div style={{ marginBottom: tokens.spacing[4], color: tokens.colors.muted }}>
          {admin.email}
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: tokens.spacing[2],
            marginBottom: tokens.spacing[5],
            color: tokens.colors.body,
          }}
        >
          Current role: <StatusBadge tone="neutral">{admin.role}</StatusBadge>
        </div>

        <FormField label="Change role" htmlFor="role-select">
          <Select
            id="role-select"
            value={pendingRole}
            onChange={(e) => setPendingRole(e.target.value)}
          >
            <option value="">—</option>
            {roles.map((r) => <option key={r.name} value={r.name}>{r.name}</option>)}
          </Select>
        </FormField>

        <Button
          disabled={!pendingRole || pendingRole === admin.role}
          onClick={() => setShowReason(true)}
        >
          Update role
        </Button>
      </Card>

      {showReason && (
        <ReasonCaptureModal
          title="Assign new role"
          onCancel={() => setShowReason(false)}
          onConfirm={submit}
        />
      )}
    </PageLayout>
  );
}
